var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg"},[_c('v-card-text',[_c('div',{attrs:{"id":"swagger-ui"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }